module.exports = {
      id: "app-download-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "svg-sprite-c71831da97eff2ec188167649c252867.svg#app-download",
      toString: function () {
        return this.url;
      }
    }